import Error from "@pathwright/ui/src/components/error/Error"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import type { ComponentType } from "react"

type CertificateErrorAction = {
  icon?: string
  label?: string
  onClick?: () => void
  to?: string
}

type InvalidCertificateTemplateErrorProps = {
  onSelectPdf?: () => void
  primaryAction?: CertificateErrorAction
}

// The JS Error component's inferred props mark unused fields as required.
const CertificateError = Error as unknown as ComponentType<{
  errorTitle: string
  errorMessage: string
  primaryAction?: CertificateErrorAction
}>

const InvalidCertificateTemplateError = ({
  onSelectPdf,
  primaryAction
}: InvalidCertificateTemplateErrorProps) => {
  const { t } = useTranslate()
  const tPrefix = "certificate.invalid"

  return (
    <CertificateError
      errorTitle={t(`${tPrefix}.title`, "Invalid certificate template.")}
      errorMessage={t(
        `${tPrefix}.description`,
        "Select a single-page PDF to replace this template."
      )}
      primaryAction={
        onSelectPdf
          ? {
              icon: "arrow-up-circle",
              label: t(`${tPrefix}.action`, "Select a PDF"),
              onClick: onSelectPdf
            }
          : primaryAction
      }
    />
  )
}

InvalidCertificateTemplateError.displayName = "InvalidCertificateTemplateError"

export default InvalidCertificateTemplateError
